import React from 'react';
import moment from 'moment';


export const TimeTravelContext = React.createContext({} as {
  date: moment.Moment,
  setDate: (newDate: moment.Moment) => void,
});

export function TimeTravelContextProvider({children}: {children: React.ReactNode}) {
  const [date, setDate] = React.useState(moment().startOf('quarter').subtract(1, 'day'));

  return (
    <TimeTravelContext.Provider value={{
      date,
      // Without creating new object with moment(newDate), useContext does not trigger re-render
      setDate: (newDate: moment.Moment) => setDate(moment(newDate)),
    }}>
      {children}
    </TimeTravelContext.Provider>
  )
}